import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HeaderComponent } from './layouts/header/header.component';
import { FooterComponent } from './layouts/footer/footer.component';
import { MenuComponent } from './layouts/menu/menu.component';
import { RatInputComponent } from './layouts/rat-input/rat-input.component';
import { RatSelectComponent } from './layouts/rat-select/rat-select.component';
import { RatErrormsgComponent } from './layouts/rat-errormsg/rat-errormsg.component';
import { QuestionComponent } from './layouts/question/question.component';
import { RatButtonComponent } from './layouts/rat-button/rat-button.component';
import { QuestionnaireTabsComponent } from './layouts/questionnaire-tabs/questionnaire-tabs.component';
import { NotificationComponent } from './layouts/notification/notification.component';
import { RatMultiselectComponent } from './layouts/rat-multiselect/rat-multiselect.component';
import { RatLoaderComponent } from './layouts/rat-loader/rat-loader.component';
import { GeneratePdfComponent } from './layouts/generate-pdf/generate-pdf.component';
import { UploadingComponent } from './models/uploading/uploading.component';


@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    MenuComponent,
    RatInputComponent,
    RatSelectComponent,
    RatErrormsgComponent,
    QuestionComponent,
    RatButtonComponent,
    QuestionnaireTabsComponent,
    NotificationComponent,
    RatMultiselectComponent,
    RatLoaderComponent,
    GeneratePdfComponent,
    UploadingComponent
  ],
  imports: [
    CommonModule, ReactiveFormsModule, FormsModule
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    MenuComponent,
    RatInputComponent,
    RatSelectComponent,
    RatErrormsgComponent,
    QuestionComponent,
    RatButtonComponent,
    QuestionnaireTabsComponent,
    NotificationComponent,
    RatMultiselectComponent,
    RatLoaderComponent,
    GeneratePdfComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class SharedModule { }
